/** Junta classes ignorando falsy. Sem dependencia: o uso aqui e simples. */
export function cn(...partes: Array<string | false | null | undefined>): string {
  return partes.filter(Boolean).join(' ')
}
